export const requestSelectedLocation = () => {
  return {
    type: 'REQUEST_SELECTED_LOCATION',
  }
}

export const receiveSelectedLocation = locationName => {
  return {
    type: 'RECEIVE_SELECTED_LOCATION',
    locationName: locationName,
  }
}

export const receiveSelectedCategory = categoryName => {
  return {
    type: 'RECEIVE_SELECTED_CATEGORY',
    categoryName: categoryName,
  }
}
